<template>
  <div class='row-libray'>
    <LeftListMember :pos="6"></LeftListMember>
    <div class="g-row2">
      <div class="m-hone1 m-libray">
        <!-- <div v-if="$store.state.user.userInfo.type != 2" class="top">
          <div class="tit">按供应商名称查询：</div>
          <a-input-search class="m-so" placeholder="请输入供应商名称" v-model="search.supplier" @search="onSearch" />
        </div> -->
        <div class="m-searchnew">
          <div class="form">
            <div class="left-tit">按条件查询：</div>
            <div class="right-inp">
              <div class="inp">
                <el-input v-model="search.isbn" type="text" name="" id="" placeholder="请输入标准书号" />
              </div>
              <div class="inp">
                <el-input v-model="search.name" type="text" name="" id="" placeholder="请输入书名" />
              </div>
              <div class="inp">
                <el-input v-model="search.publisher" type="text" name="" id="" placeholder="请输入出版社名称" />
              </div>
              <div class="inp">
                <el-input v-model="search.author" type="text" name="" id="" placeholder="请输入作者名称" />
              </div>
              <div class="inp">
                <el-input v-model="search.supplier" type="text" name="" id="" placeholder="请输入供应商名称" />
              </div>
            </div>
            <button class="btn" @click="load(1)"><img src="@/assets/images/index/icon6.png" class="icon" alt="" style="max-height: 60%;" /></button>
          </div>
        </div>

        <div class="contect g-contecte1">
          <div class="top1">
            <div class="tit2">订单列表</div>
          </div>
          <div class="top1">
            <div class="con3">
              <form action="">
                  <div class="form2">
                    <div class="left3">
                    <div class="form2-txt">批量修改订单数：</div>
                    <el-input type="text" v-model="batchSetNum" class="inp" placeholder="请输入数值" style="border:none;"/>
                  </div>
                  <div class="right3">
                    <div class="btn1" @click="btnBatchSetNum">确认提交</div>
                    <div class="btn1" @click="showModal">查重设置</div>
                    <div class="btn1 btn2" @click="batchDel">批量删除</div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="m-boxm1">
            <div class="left1">
              <div class="group">总码洋：<span>{{ bookCount.totalPrice }}</span> 元</div>
              <div class="group">总实洋：<span>{{ bookCount.actualPrice }}</span> 元</div>
              <div class="group">总订数：<span>{{ bookCount.totalNum }}</span> 册</div>
              <div class="group">品种数：<span>{{ bookCount.totalCategoryNum }}</span> 种</div>
            </div>
            <button class="btn" @click="getBookCount">点击统计</button>
          </div>

          <div class="m-table m-table-collection">

            <a-table :scroll="{ x: 700 }" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" rowKey="id" :columns="columns"
              :data-source="data" :pagination="false" :bordered="false" :rowClassName="(row,i)=>row.isDuplicate?'duplicate-row':''">
              <div slot="delete" slot-scope="index, record, indent, expanded" class="delete" style="color: #188EFC;" @click="del(record.id)">
                <span>删除</span>
              </div>
              <div slot="publishDate"><span class="td1 on" :class="{ active1: isOrderPublishDateOn }"
                                            @click="toggleActive1">出版日期<img src="@/assets/images/e-load2.png" class="icon" alt="" /><img
                  src="@/assets/images/e-load2-on.png" class="icon icon2" alt="" /></span></div>

              <div slot="supplier" slot-scope="supplier, record, indent, expanded">
                <a @click="openSupplier(record.book.uid)" class="supplier" >{{ record.book.supplier }}</a>
              </div>
              <div slot="fixprice"><span class="td1" :class="{ active2: isOrderPriceOn }" @click="toggleActive2">定价<img
                  src="@/assets/images/e-load1.png" class="icon" alt="" /><img src="@/assets/images/e-load1-on.png"
                                                                               class="icon icon2" alt="" /></span></div>
              <div slot="discount"><span class="td1 td2 " :class="{ active: isOrderDiscountOn }" @click="toggleActive">折扣<img
                  src="@/assets/images/e-icon4.png" class="icon" alt="" /><img src="@/assets/images/e-icon4-on.png"
                                                                               class="icon icon2" alt="" /></span></div>

              <div slot="step" class="m-step" slot-scope="step, record, indent, expanded,">
                <div class="m-stepe1">
                  <button @click="decrement(record)" :style="{color: record.num <=1? '#CBCBCB':'#000000'}">-</button>
                  <input type="number" v-model="record.num" :min="1" @change="e=>numChange(record)"></input>
                  <button @click="increment(record)">+</button>
                </div>
              </div>
            </a-table>


          </div>
          <mPages :page.sync="filter.page" :page-size.sync="filter.pageSize" :total="dataCount" />
          <div class="m-order-bottom">
            <div class="tit" style="display: flex;align-items: center;"><span style="color: red;">* </span>订单名称
              <span class="m-so" style="width: unset;margin-left: 10px;">
                <a-input class="ant-input" placeholder="请输入此订单的项目名称" v-model="orderTitle" style="width: 300px;border-right: 1px solid #CBD2D8;"/>
              </span>
            </div>
            <div class="tit" style="display: flex;align-items: center;margin-left: 30px;">订单备注
              <span class="m-so" style="width: unset;margin-left: 10px;">
                <a-input class="ant-input" placeholder="请输入订单备注" v-model="orderRemark" style="width: 300px;border-right: 1px solid #CBD2D8;"/>
              </span>
            </div>
            <div class="m-btnorder" @click="submitOrder" style="cursor: pointer;margin: 0;margin-left: 20px;">提交到供应商</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <a-modal
          :visible="visible"
          @cancel="handleCancel"
          :footer="null"
          :centered="true"
          :closable="false"
          :width="808"
          wrapClassName="popbox2"
          :maskStyle="{backgroundColor: 'rgba(0, 0, 0, 0.75)'}"
        >
          <div class="m-popod1">
            <div class="top1">
              <div class="tit1">查重设置弹窗</div>
              <div class="close" @click="handleCancel"><img src="@/assets/images/cls.png" class="icon" alt="" /></div>
            </div>
            <div class="inner">
              <div class="left">
                  <div class="radiogroup">
                    <el-radio-group v-model="duplicateCheckType" fill="#333">
                      <el-radio label="none">不查重  </el-radio>
                      <el-radio label="isbn">书号查重</el-radio>
                      <el-radio label="title">题名查重</el-radio>
                    </el-radio-group>
                  </div>
                  <div class="btns">
                    <file-upload accept=".xlsx" v-model="fileUrl" :show-file-list="false" style="position: relative;display: inline-block;">
                        <div class="btn" style="cursor: pointer;">上传馆藏数据</div>
                    </file-upload>
                    <div class="btn btn2"><a href="/static/bkHome/template/duplicateTemplate.xlsx" download style="color: white;">下载模板</a></div>
                  </div>
                  <div class="checkbox">
                    <div class="left2"><el-checkbox v-model="isCheckOnBatch" /></div>
                    <div class="right2">批量加入订单时强制查重不提示相关信息</div>
                  </div>
                  <div class="tabpic">
                    <div class="tit2">模板如下图:</div>
                    <div class="pic"><img src="@/assets/images/table.jpg" class="img" alt="" /></div>
                  </div>
              </div>
              <div class="right">
                <div class="m-infobox5">
                  <div class="box3">
                    <div class="top">
                      <div class="tit">重复提示</div>
                    </div>
                    <div class="txt">
                      <p>发现以下重复信息：</p>
                      <p>书号：9787213112201</p>
                      <p>题名：打破社交媒体镜</p>
                      <p>出版社：浙江人民出版社</p>
                      <p>作者：(美)克里斯·贝尔(Chris Bai1)</p>
                      <p>定价：59.00</p>
                      <p>索书号：G05/B720</p>
                      <p>数量：5本</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-modal>
  </div>
</template>

<script>
import mPages from '@/components/mpages/mPages.vue'
import LeftListMember from "@/components/LeftListMember.vue";
import {getApiData, getApiRes} from "@/api/apiUtil";
import apiBkBookCart from "@/api/bkBookCart";
import apiUserInfo from "@/api/userInfo";
import apiBkBookOrder from "@/api/bkBookOrder";
import FileUpload from "@/views/common/FileUpload.vue";
import apiBkBook from "@/api/bkBook";
import apiBkUserLibrary from "@/api/bkUserLibrary";
export default {
  components: {
    FileUpload,
    LeftListMember,
    mPages,
  },
  data() {
    return {
      duplicateCheckType: "none",
      isCheckOnBatch: false,
      fileUrl: '',
      saving: false,
      //
      isOrderPublishDateOn: false,
      isOrderPriceOn: false,
      isOrderDiscountOn: false,
      //
      // 步进器
      value: 0,
      // 步进器 end
      ModalText: "Content of the modal",
      visible: false,
      confirmLoading: false,
      batchSetNum: '',
      // 表单
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      // 表格
      selectedRowKeys: [], // Check here to configure the default column
      columns: [
        {
          title: "ISBN",
          dataIndex: "book.isbn",
          key: "book.isbn",
          width: '9.5%',
        },
        {
          title: "书名",
          dataIndex: "book.name",
          key: "book.name",
          width: '28.9%',
          ellipsis: true,
        },
        {
          title: "出版社",
          dataIndex: "book.publisher",
          key: "book.publisher",
          width: '9.5%',
          ellipsis: true,
        },
        {
          title: "作者",
          dataIndex: "book.author",
          key: "book.author",
          ellipsis: true,
          width: '4.7%',
        },

        {
          title: "发行时间",
          dataIndex: "book.publishDate",
          key: "book.publishDate",
          ellipsis: true,
          width: '7.4%',
          slots: { title: 'publishDate' },
          scopedSlots: { customRender: '发行时间' },
        },

        // {
        //   title: "印刷日期",
        //   dataIndex: "book.printDate",
        //   key: "book.printDate",
        //   ellipsis: true,
        //   width: '6.6%',
        // },
        {
          title: "开本",
          dataIndex: "book.pageSize",
          key: "book.pageSize",
          ellipsis: true,
          width: '3.3%',
        },
        {
          // title: "定价",
          dataIndex: "book.price",
          key: "book.price",
          ellipsis: true,
          width: '6.1%',
          // sorter: true,
          // scopedSlots: { customRender: 'name' },
          slots: { title: 'fixprice' },
          scopedSlots: { customRender: '定价' },
        },
        {
          // title: "折扣",
          dataIndex: "book.discount",
          key: "book.discount",
          ellipsis: true,
          width: '6.1%',
          slots: { title: 'discount' },
          scopedSlots: { customRender: '折扣' },
        },

        {
          title: "供应商",
          dataIndex: "book.supplier",
          key: "book.supplier",
          ellipsis: true,
          width: '8.8%',
          scopedSlots: { customRender: 'supplier' },
        },
        {
          title: "订单数",
          dataIndex: "num",
          key: "num",
          ellipsis: true,
          width: '6.8%',
          scopedSlots: { customRender: 'step' },

        },

        {
          title: "操作",
          dataIndex: "operate",
          key: "operate",
          ellipsis: true,
          width: '6.1%',
          scopedSlots: { customRender: 'delete' },
        },

      ],

      data: [],
      dataCount: 0,
      search: {
        isbn: '',
        name: '',
        publisher: '',
        author: '',
        supplier: ''
      },
      filter: {
        isBook: true,
        page: 1,
        pageSize: 100,
        order: undefined
      },
      orderTitle: '',
      orderRemark: '',
      bookCount: {
        totalPrice: '****',
        actualPrice: '****',
        totalNum: '****',
        totalCategoryNum: '****',
      }
    };
  },
  computed: {},
  watch: {
    filter:{
      handler() {
        this.load()
      },
      deep: true
    },
    isOrderDiscountOn(){
      this.getOrder('discount')
    },
    isOrderPriceOn(){
      this.getOrder('price')
    },
    isOrderPublishDateOn(){
      this.getOrder('publishDate')
    },
    duplicateCheckType(){
      this.setDuplicateConfig()
    },
    isCheckOnBatch(){
      this.setDuplicateConfig()
    },
    visible(v){
      if(!v) {
        this.fileUrl = ''
        this.checkDuplicateBooks()
        this.load()
      }
    },
    fileUrl(v){
      if(v){
        this.importBooks()
      }
    }
  },
  async mounted() {
    this.load(1)

    // 检测认证
    if(this.$store.state.user.userInfo.type != 2 && this.$store.state.user.company.status != 2) { //会员和供应商需要认证
      return this.$alert('请先完成资质认证', '提示', {callback:()=>this.$router.push(this.$store.state.user.userInfo.type == 1 ? '/info-qualifications' : '/center-qualifications')})
    }

    await this.getDuplicateConfig()
    await this.checkDuplicateBooks()
  },
  methods: {
    async submitOrder(){
      if(!this.orderTitle) return this.$message.error('请输入订单项目名称')
      let reConfirm = await this.$confirm('确定要提交订单吗?').catch((e)=>false)
      if(!reConfirm) return
      let re = await getApiRes(apiBkBookOrder.submit(this.orderTitle, this.orderRemark), 0, 1,1,1)
      if(re) {
        this.load(1)
      }
    },
    getOrder(orderBy){
      let orders = []
      orders.push('publishDate '+ (this.isOrderPublishDateOn ? 'asc' : 'desc'))
      orders.push('price ' + (this.isOrderPriceOn ? 'asc' : 'desc'))
      orders.push('discount ' + (this.isOrderDiscountOn ? 'asc' : 'desc'))
      orders.sort((a,b)=>a.indexOf(orderBy)>-1?-1:1) //按参数字段排在前面
      this.filter.order = orders.join(',')
    },
    async load(page=undefined){
      if(page) this.filter.page = page
      let map = []
      if(this.search.isbn) map.push(['isbn','like',`%${this.search.isbn}%`])
      if(this.search.name) map.push(['name','like',`%${this.search.name}%`])
      if(this.search.publisher) map.push(['publisher','like',`%${this.search.publisher}%`])
      if(this.search.author) map.push(['author','like',`%${this.search.author}%`])
      if(this.search.supplier) map.push(['supplier','like',`%${this.search.supplier}%`])
      let re = await getApiRes(apiBkBookCart.getList(this.filter.page,this.filter.pageSize,map,'',[],this.filter), 0, 1,1)
      this.data = re.data
      this.dataCount = re.count
    },
    async del(id){
      let reConfirm = await this.$confirm('确定要删除吗?').catch((e)=>false)
      if(!reConfirm) return
      let re = await getApiRes(apiBkBookCart.listDel(id),0,1,1,1)
      if(re.code==0){
        this.load()
      }
    },
    async batchDel(){
      if(this.selectedRowKeys.length==0) return this.$message.error('请选择要删除的数据')
      let reConfirm = await this.$confirm('确定要删除吗?').catch((e)=>false)
      if(!reConfirm) return
      let re = await getApiRes(apiBkBookCart.listDel(this.selectedRowKeys),0,1,1,1)
      if(re.code==0){
        this.load()
      }
    },
    async openSupplier(uid){
      let re = await getApiRes(apiUserInfo.GetShowIdByUid(uid),0,1,1,0)
      if(re.code==0 && re.data){
        window.open('/home/user_info/home?id='+re.data, '_blank')
      }
    },
    // 类名
    toggleActive1() {
      this.isOrderPublishDateOn = !this.isOrderPublishDateOn;
    },
    toggleActive2() {
      this.isOrderPriceOn = !this.isOrderPriceOn;
    },
    toggleActive() {
      this.isOrderDiscountOn = !this.isOrderDiscountOn;
    },
    // 类名end
    showModal() {
      this.visible = true;
    },
    handleCancel(e) {
      this.visible = false;
    },
    // 表格
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },
    // 步进器
    increment(row) {
      row.num = parseInt(row.num)
      row.num+=1
      getApiRes(apiBkBookCart.setNum(row.id, row.num), 0, 1,0,0)
    },
    decrement(row) {
      row.num = parseInt(row.num)
      if(row.num<=1) return
      row.num-=1
      getApiRes(apiBkBookCart.setNum(row.id, row.num), 0, 1,0,0)
    },
    numChange(row, num){
      getApiRes(apiBkBookCart.setNum(row.id, row.num), 0, 1,0,0)
    },
    async btnBatchSetNum(){
      await getApiRes(apiBkBookCart.batchSetNum(this.selectedRowKeys, this.batchSetNum), 0, 1,1,1)
      this.load()
    },
    async getBookCount(){
      let re = await getApiRes(apiBkBookCart.getBookCount(), 0, 1,1)
      if(re.code==0) this.bookCount = re.data
    },
    async getDuplicateConfig(){
      let config = await getApiData(apiUserInfo.getDuplicateConfig(),0,1,1)
      if(config){
        this.duplicateCheckType = config.duplicateCheckType || 'none'
        this.isCheckOnBatch = !!config.isCheckOnBatch
      }
    },
    async setDuplicateConfig(){
      console.log(this.duplicateCheckType, this.isCheckOnBatch)
      await getApiRes(apiUserInfo.setDuplicateConfig(this.duplicateCheckType, this.isCheckOnBatch ? 1 :0),0,1,1)
    },
    async importBooks(){
      // if(!this.checkCompanyAuth()) return this.$alert('请先完成资质认证', '提示', {callback:()=>this.$router.push(this.$store.state.user.userInfo.type == 1 ? '/info-qualifications' : '/center-qualifications')})
      if(this.saving) return
      if(!this.fileUrl) return this.$message.error('请选择文件')
      this.saving = true;
      let re = await getApiRes(apiBkUserLibrary.import(this.fileUrl),0,1,0,0)
      this.saving = false;
      this.fileUrl = ''
      // this.visible = false
      if(re.code==0){
        this.load(1)
        this.$success({
          title: '成功',
          content: re.msg
        })
      }else{
        this.$error({
          title: '失败',
          content: re.msg
        })
      }
    },
    async checkDuplicateBooks(){
      let re = await getApiRes(apiBkBookCart.checkDuplicateBooks(),0,1,0,0)
      if(re.data && re.data.length){
        this.$alert(
            `共检测到${re.count}条重复数据，前十条重复ISBN为：${re.data.map(x=>x.book.isbn).join(';')}（在列表中标记为黄色）`,
            '提示'
        )
      }
    },
    getRowClass(row, index){
      console.log(row, index)
      if(row.isDuplicate){
        return 'duplicate-row'
      }
      return ''
    }
  },
};

</script>

<style lang="scss" scoped>
.ant-input-affix-wrapper .ant-input-suffix {
  right: 0;
}
::v-deep .duplicate-row{
  background: #eee9b1 !important;
}
</style>
